// Tipos
type InitFn = (root?: HTMLElement) => void;

// --- Registro por página (opción A: <html data-page="...">) ---
import { initHome } from './pages/home';
import { initAdmin } from './pages/admin';

const pageRegistry: Record<string, InitFn> = {
  home: initHome,
  admin: initAdmin,
};

// --- Registro por "zonas" (opción B: data-controller="...") ---
import { initGallery } from './controllers/gallery';
import { initChart } from './controllers/chart';
import { initCarrusel } from './controllers/carrusel';
import { initMenuMovil } from './controllers/menu-movil';
import { initCompartir } from './controllers/compartir';
import { initBuscador } from './controllers/buscador';

const controllerRegistry: Record<string, InitFn> = {
  gallery: initGallery,
  chart: initChart,
  carrusel: initCarrusel,
  'menu-movil': initMenuMovil,
  compartir: initCompartir,
  buscador: initBuscador,
};

// Helper: inicializa todos los nodos que pidan un controller
function bootControllers() {
  const nodes = document.querySelectorAll<HTMLElement>('[data-controller]');
  nodes.forEach((node) => {
    const names = node.dataset.controller?.split(',').map(s => s.trim()).filter(Boolean) ?? [];
    names.forEach((name) => controllerRegistry[name]?.(node));
  });
}

// Helper: inicializa la página según data-page en <html> o <body>
function bootPage() {
  const el = document.documentElement.dataset.page
    ? document.documentElement
    : document.body;

  const page = el.dataset.page;
  if (page && pageRegistry[page]) pageRegistry[page](document.body);
}

// Arranque
document.addEventListener('DOMContentLoaded', () => {
  bootPage();        // Opción A
  bootControllers(); // Opción B (islas/zonas)
});